import React from "react";
import { Link } from "react-router-dom";
import { X, BookOpen } from "lucide-react";
import { useHelp } from "./HelpContext";
import { getArticle } from "./articles/index";
import MarkdownContent from "./MarkdownContent";

export default function HelpDrawer() {
  const { open, articleSlug, closeHelp } = useHelp();

  if (!open) return null;

  const article = getArticle(articleSlug);

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/20"
        onClick={closeHelp}
        aria-hidden="true"
      />
      <aside
        className="fixed right-0 top-0 bottom-0 z-50 flex flex-col w-full max-w-sm shadow-2xl"
        style={{ background: "#FBFAF7", borderLeft: "1px solid var(--fb-border)" }}
        role="dialog"
        aria-label="Help"
        aria-modal="true"
      >
        <div
          className="flex items-center justify-between px-5 py-4 border-b shrink-0"
          style={{ borderColor: "var(--fb-border)" }}
        >
          <div className="flex items-center gap-2">
            <BookOpen className="w-4 h-4 shrink-0" style={{ color: "var(--fb-text-muted)" }} />
            <span className="text-sm font-semibold" style={{ color: "var(--fb-text)", fontFamily: "Outfit" }}>
              Help
            </span>
          </div>
          <button
            onClick={closeHelp}
            aria-label="Close help"
            className="p-1.5 rounded-lg hover:bg-stone-200 transition-colors"
          >
            <X className="w-4 h-4" style={{ color: "var(--fb-text-muted)" }} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-5">
          {article ? (
            <MarkdownContent content={article.content} />
          ) : (
            <p className="text-sm" style={{ color: "var(--fb-text-muted)" }}>
              No help article found for this page.
            </p>
          )}
        </div>

        <div
          className="shrink-0 px-5 py-4 border-t"
          style={{ borderColor: "var(--fb-border)" }}
        >
          <Link
            to="/staff/help"
            onClick={closeHelp}
            className="flex items-center gap-1.5 text-sm font-medium hover:underline"
            style={{ color: "var(--fb-green, #4A7C59)" }}
          >
            <BookOpen className="w-3.5 h-3.5" />
            Browse all docs
          </Link>
        </div>
      </aside>
    </>
  );
}
